import React from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';

const ViewMessageModal = ({ isOpen, handleClose, message, context = {} }) => {
  const { phone, purpose, sentAt } = context;
  const hasMeta = phone || purpose || sentAt;

  return (
    <Modal isOpen={isOpen} toggle={handleClose} backdrop="static" size="md">
      <ModalHeader toggle={handleClose}>Full Message</ModalHeader>
      <ModalBody>
        {hasMeta && (
          <Row className="mb-3" style={{ fontSize: '0.9rem' }}>
            {phone && (
              <Col md="4" className="mb-2">
                <span className="text-muted">Mobile Number</span>
                <div><strong>{phone}</strong></div>
              </Col>
            )}
            {purpose && (
              <Col md="4" className="mb-2">
                <span className="text-muted">Purpose</span>
                <div><strong>{purpose}</strong></div>
              </Col>
            )}
            {sentAt && (
              <Col md="4" className="mb-2">
                <span className="text-muted">Message Sent</span>
                <div><strong>{sentAt}</strong></div>
              </Col>
            )}
          </Row>
        )}
        <div
          style={{
            padding: '0.75rem 1rem',
            background: '#f8f9fa',
            borderRadius: '6px',
            fontSize: '0.95rem',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            lineHeight: '1.5'
          }}
        >
          {message || '—'}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ViewMessageModal;
